<section
  class="report-dialog"
  [ngClass]="{ 'report-dialog--mobile-sheet': isMobileView() }">
  <div class="report-dialog__header">
    <div class="report-dialog__title-box">
      <div class="report-dialog__icon-wrap">
        <i class="iconsax report-dialog__icon" icon-name="info-circle"></i>
      </div>
      <h3 class="report-dialog__title">
        {{ 'reportComment.title' | translate }}
      </h3>
    </div>
    <button
      type="button"
      class="report-dialog__close"
      (click)="close()"
      [attr.aria-label]="'global.close' | translate">
      <i class="iconsax" icon-name="x"></i>
    </button>
  </div>

  <p class="report-dialog__description">
    {{ 'reportComment.description' | translate }}
  </p>

  <div class="report-dialog__reasons">
    @for (reason of reasons; track reason.value) {
      <button
        type="button"
        class="report-dialog__reason"
        [class.report-dialog__reason--active]="selectedReason() === reason.value"
        (click)="selectReason(reason.value)">
        {{ reason.labelKey | translate }}
      </button>
    }
  </div>

  <div class="report-dialog__actions">
    <button type="button" class="report-dialog__action report-dialog__action--cancel" (click)="close()">
      {{ 'reportComment.cancel' | translate }}
    </button>
    <button
      type="button"
      class="report-dialog__action report-dialog__action--submit"
      [disabled]="!selectedReason() || submitting()"
      (click)="submit()">
      {{ 'reportComment.submit' | translate }}
    </button>
  </div>
</section>
